import { AutogenModelPartialShipmentManifestStopDetails, AutogenRowPartialShipmentManifestStopDetails } from "./autogen/AutogenModelPartialShipmentManifestStopDetails";

export class ModelPartialShipmentManifestStopDetails extends AutogenModelPartialShipmentManifestStopDetails<RowPartialShipmentManifestStopDetails> {
	constructor() {
		super(RowPartialShipmentManifestStopDetails);
	}
}

export class RowPartialShipmentManifestStopDetails extends AutogenRowPartialShipmentManifestStopDetails {
}